import { render, staticRenderFns } from "./social-media-managers.vue?vue&type=template&id=8f5b34c0&scoped=true&"
import script from "./social-media-managers.vue?vue&type=script&lang=js&"
export * from "./social-media-managers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5b34c0",
  null
  
)

export default component.exports